// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"InvitationView-module__loadingWrapper--ReIPH"};